import { ActionConfirmation } from "../ui/ActionConfirmation.js";
import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { register } from "../api.js";
import { Brand } from "../Brand.js";

/**
 * Registering.
 *
 * The confirmation says the same thing whatever the server found — a new
 * address, one registered but never confirmed, or one that already has an
 * account. Anything more specific would turn this form into a way of asking
 * which families are here.
 *
 * Nobody is signed in at the end of it. The account exists, attached to
 * nothing, until the link in the email is used.
 */
export function Register() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await register(email.trim().toLowerCase());
      setSent(true);
    } catch (cause: unknown) {
      setError(cause instanceof Error ? cause.message : "Could not register.");
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <div className="signin">
        <div style={{ width: 320 }}>
          <Brand title="Wirral Music Factory" subtitle="Hub" className="brand-auth" />
          <ActionConfirmation variant="success" title="Account confirmation requested" description={<>
            Check your email. There is a link there to confirm the address and finish setting up
            the account — it lasts three days. You will choose your password when you use it.
           </>} />
          <p className="small muted">
            Nothing is set up until you use it. If nothing arrives, check the spam folder, and that
            the address is the one the school holds for you.
          </p>
          <Link className="small" to="/">
            Back to sign in
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="signin">
      <form onSubmit={submit}>
        <Brand title="Wirral Music Factory" subtitle="Hub" className="brand-auth" />

        {error && <div className="error small">{error}</div>}

        <label className="small muted" htmlFor="email">
          Email
        </label>
        {/* The address the school already holds for you, ideally: it is what
            attaches the account to your children's records. */}
        <input
          id="email"
          type="email"
          autoComplete="email"
          autoCapitalize="none"
          spellCheck={false}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <p className="small muted" style={{ margin: 0 }}>
          We will email you a link to confirm your address and choose your password.
        </p>

        <button type="submit" disabled={busy}>
          {busy ? "Sending…" : "Send setup link"}
        </button>

        <Link className="small muted" to="/">
          Already have an account? Sign in
        </Link>
      </form>
    </div>
  );
}
